import { useI18n } from '../context/I18nContext';
import Seo from '../components/Seo';
import HomeHeroSection from '../components/home/HomeHeroSection';
import HomeShowcaseSliderSection from '../components/home/HomeShowcaseSliderSection';
import ImageParallax from '../components/home/ImageParallax';
import HomeServicesSection from '../components/home/HomeServicesSection';
import HomePromotionsSection from '../components/home/HomePromotionsSection';
import HomeSparePartsSection from '../components/home/HomeSparePartsSection';
import HomeValuePointsSection from '../components/home/HomeValuePointsSection';
import HomeVideoBannerSection from '../components/home/HomeVideoBannerSection';
import { absoluteUrl, getSiteUrl } from '../lib/seo';

export default function Home() {
  const { language } = useI18n();
  const siteUrl = getSiteUrl();
  const seoTitle =
    language === 'fr'
      ? 'ETC Company | Équipements de manutention, pièces de rechange et services'
      : 'ETC Company | Warehouse equipment, spare parts, and services';
  const seoDescription =
    language === 'fr'
      ? 'ETC Company aide les entreprises avec des équipements de manutention fiables, des pièces de rechange et un support commercial réactif.'
      : 'ETC Company helps businesses with reliable warehouse equipment, spare parts, and responsive commercial support.';
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'ETC Company',
      url: siteUrl,
      logo: absoluteUrl('/logos/logo.svg', siteUrl),
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'ETC Company',
      url: siteUrl,
    },
  ];

  return (
    <div key={language}>
      <Seo
        title={seoTitle}
        description={seoDescription}
        keywords={{
          en: [
            'warehouse equipment Tunisia',
            'forklift supplier',
            'spare parts supplier',
            'material handling solutions',
            'commercial support',
          ],
          fr: [
            'équipements de manutention Tunisie',
            'fournisseur de chariots élévateurs',
            'pièces de rechange',
            'solutions de manutention',
            'support commercial',
          ],
        }}
        jsonLd={jsonLd}
      />
      <HomeShowcaseSliderSection />
      <HomeHeroSection />
      <HomePromotionsSection />
      <HomeVideoBannerSection />
      <HomeServicesSection />
      <ImageParallax />
      <HomeSparePartsSection />
      <HomeValuePointsSection />
    </div>
  );
}
